/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
import { percentStringHelper, REPORTS_PRECISION_DEFAULT } from 'embercom/lib/percentage-formatter';

export default buildHelper(function (params) {
  return percentStringHelper(params, REPORTS_PRECISION_DEFAULT);
});
